import useFaqT from "./useFaqT";
import { FAQ_SHOW_KEYS } from "../../constants/faq/faqConfig";

// Step list (design sheet C): numbered 22px circles, no fixed height, wraps
// freely. Marker n ↔ step n coupling both ways — hover (desktop) and
// tap/keyboard (mobile) activate; active step gets tint bg + accent bar +
// accent number. Rows are keyboard-reachable (Enter/Space toggles).
// Mobile (<md): full width under the image, ≥44px rows, mono keys hidden.
const FaqStepList = ({ steps, activeN, onActivate, onDeactivate, onTap }) => {
  const tr = useFaqT();
  if (!steps || !steps.length) return null;

  return (
    <ol className="m-0 flex list-none flex-col gap-0.5 p-0">
      {steps.map((s) => {
        const on = activeN === s.n;
        return (
          <li
            key={s.n}
            data-testid={`faq-step-${s.n}`}
            role="button"
            tabIndex={0}
            aria-pressed={on}
            onMouseEnter={() => onActivate && onActivate(s.n)}
            onMouseLeave={() => onDeactivate && onDeactivate()}
            onFocus={() => onActivate && onActivate(s.n)}
            onBlur={() => onDeactivate && onDeactivate()}
            onClick={() => onTap && onTap(s.n)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                if (onTap) onTap(s.n);
              }
            }}
            className={`flex min-h-[44px] cursor-pointer items-start gap-3 border-l-2 p-2.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1F5EFF] md:px-3 ${
              on ? "border-[#1F5EFF] bg-[#EEF2FF]" : "border-transparent bg-transparent"
            }`}
          >
            <span
              className={`flex h-[22px] w-[22px] flex-none items-center justify-center rounded-full text-[12px] font-semibold ${
                on ? "bg-[#1F5EFF] text-white" : "bg-[#EDEEF0] text-[#5A626E]"
              }`}
            >
              {s.n}
            </span>
            <span className={`flex-1 text-[14px] leading-[1.5] ${on ? "text-[#14171C]" : "text-[#3A414C]"}`}>
              {tr(s.text)}
            </span>
            {FAQ_SHOW_KEYS && s.key && (
              <span className="hidden flex-none font-faqmono text-[10px] text-[#B4B9C2] md:block">{s.key}</span>
            )}
          </li>
        );
      })}
    </ol>
  );
};

export default FaqStepList;
